import { render, staticRenderFns } from "./post-card.vue?vue&type=template&id=7e584208&"
import script from "./post-card.vue?vue&type=script&lang=js&"
export * from "./post-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports